

import React, { useState, useEffect } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import { Helmet } from 'react-helmet';
import HomeIcon from '@mui/icons-material/Home';
import Footer from "./footer";
import Navbar from "./Navbar";

function BlogPostPage() {
  const { slug } = useParams();  // get the slug from the route parameter
  const [post, setPost] = useState(null);
  const [error, setError] = useState(null);
  const [trendingPosts, setTrendingPosts] = useState([]);  // Store trending posts
  const [searchTerm, setSearchTerm] = useState("");  // Search input state


  useEffect(() => {
    const fetchPost = async () => {
      try {
        const response = await axios.get(`https://kvch.in:859/api/post/${slug}`);
        setPost(response.data);
      } catch (err) {
        setError("Failed to fetch the blog post.");
      }
    };

    const fetchTrendingPosts = async () => {
      try {
        const response = await axios.get("https://kvch.in:859/api/posts");
        setTrendingPosts(response.data);
      } catch (err) {
        console.error("Failed to fetch trending posts.");
      }
    };

    fetchPost();
    fetchTrendingPosts();
  }, [slug]);



  const stripHtmlTags = (html) => {
    const doc = new DOMParser().parseFromString(html, "text/html");
    return doc.body.textContent || "";
  };

  const filteredTrendingPosts = trendingPosts
    .filter(post => post.title.toLowerCase().includes(searchTerm.toLowerCase()))
    .slice(0, 50); // Limit to 50 results





  if (error) {
    return <p>{error}</p>;
  }

 

  if (!post) {
    return (
      <div id="preloader">
        <div id="loader"></div>
      </div>
    );
  }

  return (
    <div>

      <Helmet>
        <title>{post.title}</title>
        <meta name="description" content={post.description} />
        <meta name="keywords" content={post.keywords} />
        <meta name="user-interest" content={post.keywords} />
        <link rel="icon" to="" type="image/x-icon" />
        <link rel="canonical" to={`https://kvch.in/blogs/${post.url}`} />
        <meta name="author" content={post.authorName} />
        <meta name="og:title" content={`${post.title}`} />
        <meta name='og:type' content="blogs" />
        <meta name="og:description" content={post.description} />
        <meta property="og:image" content={`https://kvch.in:859${post.banner_image}`} />
        <meta name="og:url" content={`https://kvch.in/blogs/${post.url}`} />
        <meta name="og:type" content="article" />
        <meta name="og:image:width" content="1200" />
        <meta name="og:image:height" content="630" />
        <meta name="og:site_name" content="SIAGAIN" />
        <meta name="distribution" content="global" />
        <meta name='subject' content="Blogs" />
        <meta name="rating" content="General" />
        <meta name="OWNER" type="email" value="hello@sisgain.ae" />
        <meta content="all" name="googlebot-Image" />
        <meta name="rating" content="5" />

        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "BlogPosting",
            "mainEntityOfPage": {
              "@type": "WebPage",
              "@id": `https://kvch.in/blogs/${post.url}`,
            },
            "headline": `${post.title}`,
            "description": `${post.description}`,
            "image": `https://kvch.in:859${post.banner_image}`,
            "author": {
              "@type": "Person",
              "name": `${post.authorName}`,
            },
          })}
        </script>

        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org/",
            "@type": "WebSite",
            "name": "SISGAIN",
            "url": "https://kvch.in",
            "potentialAction": {
              "@type": "SearchAction",
              "target": `https://kvch.in/blogs/${post.url}{search_term_string}`,
              "query-input": "required name=search_term_string"
            }
          })}
        </script>

        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org/",
            "@type": "BreadcrumbList",
            "itemListElement": [{
              "@type": "ListItem",
              "position": 1,
              "name": "Home",
              "item": "https://kvch.in/"
            }, {
              "@type": "ListItem",
              "position": 2,
              "name": "Blogs",
              "item": "https://kvch.in/blogs/#"
            }, {
              "@type": "ListItem",
              "position": 3,
              "name": `${post.title}`,
              "item": `https://kvch.in/blogs/${post.url}`
            }]
          })}
        </script>

      </Helmet>
      <Navbar />

      <section className="blog_banner publicblogBanner" >
        <div className="container">

          <h1>{post.title}</h1>
          <span className="breadcrumbs">
            <a href="https://kvch.in"> <HomeIcon /> Home</a> /
            <a href="https://kvch.in/blogs/"> Blogs </a> / 
            <a href={`/blogs/${post.url}`}> {post.title}</a>
          </span>

        </div>
      </section>

      <div className="container publicBlog">
        <div className="row">
          <div className="col-lg-9">

            <img src={`https://kvch.in:859${post.banner_image}`} alt={`${post.title} banner`} style={{ borderRadius: '5px' }} />

            <div dangerouslySetInnerHTML={{ __html: post.content }} className="mt-3" >
            </div>

            <div className="author_box">
              <div className="author_box_flex">
                <h6><img src={`https://kvch.in:859${post.authorImg}`} alt="" /> {post.authorName}</h6>
                {/* <div class="foot_social_network">
                  <h6>Share on  </h6>
                  <a href={`https://www.facebook.com/sharer/sharer.php?u=https://sisgain.com/blogs/#/${post.url}`} target="_blank" rel="noopener noreferrer">
                    <img loading="lazy" src="https://kvch.in/assets/images/home/at_facebook.svg" width="30" height="30" alt="Facebook Icon" />
                  </a>

                  <a href={`https://twitter.com/intent/tweet?url=https://sisgain.com/blogs/#/${post.url}`} target="_blank" rel="noopener noreferrer">
                    <img loading="lazy" src="https://kvch.in/assets/images/home/at_twitter.svg" width="30" height="30" alt="Twitter Icon" />
                  </a>

                  <a href={`https://www.linkedin.com/shareArticle?mini=true&url=https://sisgain.com/blogs/#/${post.url}`} target="_blank" rel="noopener noreferrer">
                    <img loading="lazy" src="https://kvch.in/assets/images/home/at_linkedin.svg" width="30" height="30" alt="LinkedIn Icon" />
                  </a>

                 
                </div> */}
              </div>
              {/* <p>Amina Sultan is the author of Wall Street Journal bestseller Everybody Writes: Your go to Guide to creating Ridiculously Good Content. She is the Chief Content Officer of SISGAIN; a Entrepreneur magazine; a Linkedin Influencer; a keynote speaker and technical writer.</p> */}
            </div>
          </div>
          <div className="col-lg-3">
            <section className="trending_sec">
              <div class="form-group position-relative trending_search">
                <input
                  type="search"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  className="form-control rounded-pill"
                  placeholder="Search By Keyword"
                  required
                />
                <button type="submit" class="search-btn border-0 bg-transparent" aria-label="Search">
                  <svg xmlns="http://www.w3.org/2000/svg" width="27" height="27" viewBox="0 0 36 36" fill="none">
                    <path d="M16.5 28.5C23.1274 28.5 28.5 23.1274 28.5 16.5C28.5 9.87258 23.1274 4.5 16.5 4.5C9.87258 4.5 4.5 9.87258 4.5 16.5C4.5 23.1274 9.87258 28.5 16.5 28.5Z" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                    <path d="M31.5 31.5L24.975 24.975" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                  </svg>
                </button>
              </div>

              <h3>Related Posts</h3>
              <span className="footer_sep2"></span>

              <div className="filtered_posts">
                {filteredTrendingPosts.map((post) => (
                  <div className="trending_div">
                    <a href={`/blogs/${post.slug}`} target="_blank">
                      <h4>{post.title}</h4>
                      <p>{stripHtmlTags(post.content)}</p>
                    </a>
                  </div>
                ))}

              </div>
            </section>
          </div>

        </div>
      </div>



      <Footer />

    </div>
  );
}

export default BlogPostPage;
